import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock, RadioTower } from "lucide-react";
import { adminLogin, setToken } from "../lib/adminApi";
import { useAuth } from "../context/AuthContext";

const formatErr = (detail) => {
  if (!detail) return "تعذر تسجيل الدخول. حاول مرة أخرى.";
  if (typeof detail === "string") {
    if (detail.includes("Invalid email or password")) return "البريد الإلكتروني أو كلمة المرور غير صحيحة.";
    if (detail.includes("Too many")) return "محاولات كثيرة. حاول مرة أخرى بعد 15 دقيقة.";
    return detail;
  }
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || "").filter(Boolean).join(" ");
  return String(detail);
};

const AdminLogin = () => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      const data = await adminLogin(email.trim(), password);
      setToken(data.token); setUser(data.user); navigate("/admin");
    } catch (e) { setErr(formatErr(e.response?.data?.detail) || e.message); }
    finally { setLoading(false); }
  };

  return <div dir="rtl" className="min-h-screen grid place-items-center bg-[#070D1B] px-6" data-testid="admin-login-page">
    <form onSubmit={submit} className="w-full max-w-md bg-[#11203A] border border-white/12 p-8 md:p-10 text-right">
      <div className="flex items-center gap-2.5 mb-8"><span className="grid place-items-center w-9 h-9 bg-[#D4AF37] text-[#0A1223]"><RadioTower size={20}/></span><span className="font-heading font-extrabold text-white text-lg">Tower<span className="text-[#D4AF37]">Link</span> <span className="text-slate-300 font-medium text-sm">CMS</span></span></div>
      <h1 className="font-heading text-2xl font-bold text-white mb-1">تسجيل الدخول</h1><p className="text-sm text-slate-400 mb-6">الدخول إلى لوحة إدارة الموقع.</p>
      {err && <div className="mb-4 text-sm text-red-400 bg-red-500/10 border border-red-500/30 px-4 py-2.5">{err}</div>}
      <label className="block mb-4"><span className="text-sm font-medium text-slate-300 mb-1.5 block">البريد الإلكتروني</span><input dir="ltr" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full bg-[#0A1223] border border-white/12 text-white px-4 py-3 focus:border-[#D4AF37] outline-none"/></label>
      <label className="block mb-6"><span className="text-sm font-medium text-slate-300 mb-1.5 block">كلمة المرور</span><input dir="ltr" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full bg-[#0A1223] border border-white/12 text-white px-4 py-3 focus:border-[#D4AF37] outline-none"/></label>
      <button type="submit" disabled={loading} className="btn-gold w-full inline-flex items-center justify-center gap-2 py-3.5 disabled:opacity-50">{loading?<Loader2 size={18} className="animate-spin"/>:<Lock size={18}/>}دخول</button>
    </form>
  </div>;
};
export default AdminLogin;
